import ModalScreenForm from 'components/ModalScreenForm';
import { useFormatMessage } from '@/hooks';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { log } from 'utils';
import {
  createScreen,
  deleteScreen,
  downloadScreenConfig,
  fetchScreens,
  generateApiKey,
  modifyScreen,
  revokeApiKey,
  setActiveScreen,
} from 'state/actions/screens';
import { clearUsersData } from 'state/actions/users';
import { regexInput } from 'utils/regex';
import './Screens.scss';
import ModalDeleteConfirmation from 'components/ModalDeleteConfirmation';
import Cards from 'design-components/Cards';
import _ from 'underscore';
// import { CopyIcon } from 'assets/icon/dynamic';
import { fetchTemplates } from 'state/actions/template';
import { ForwardIcon } from 'assets/icon';
import {
  createScreenGroup,
  deleteScreenGroup,
  fetchScreenGroups,
  modifyScreenGroup,
  setScreenGroup,
} from 'state/actions/screenGroup';
import CategoryDropdown from 'components/CategoryDropdown';
import ModalMediaCategoryForm from 'components/ModalMediaCategoryForm';
import ModalDelete from 'components/ModalDelete';
import ModalConfirmation from '../../components/ModalConfirmation';
import DropdownWrapper from 'components/DropdownWrapper';
import ModalScreenSchedulingForm from 'components/ModalScreenSchedulingForm';
import {
  createScreenScheduling,
  deleteScreenScheduling,
  fetchScreenScheduling,
  modifyScreenScheduling,
  setScreenScheduling,
} from 'state/actions/screenScheduling';

export default function Screens({ history }) {
  const { siteId, siteName } = useParams();

  const {
    // sites,
    error,
    loading,
    loadingScreenGroup,
    loadingScreenScheduling,
    deleted,
    updated,
    screensList,
    screenGroupList,
    screenSchedulingList,
    screenScheduling,
    userData,
    role,
    screenGroup,
  } = useSelector(
    (state) => ({
      sites: state.sites.list,
      error: state.screens.error,
      loading: state.screens.loading,
      loadingScreenGroup: state.screengroup.loading,
      loadingScreenScheduling: state.screenScheduling.loading,
      screenGroupList: state.screengroup.list,
      screenSchedulingList: state.screenScheduling.list,
      screenScheduling: state.screenScheduling.scheduling,
      deleted: state.screens.deleted,
      updated: state.screens.updated,
      screensList: state.screens.list,
      userData: state.auth.userData,
      role: state.auth.userData.role,
      screenGroup: state.screengroup.screenGroup,
    }),
    shallowEqual
  );
  console.log('screensList', screensList);
  const defaultScreen = {
    name: '',
    description: '',
    modifiedAt: moment(Date.now()).format('DD-MM-YY hh:mm:ss'),
    modifiedBy: userData.email ? userData.email : '',
  };

  const [deleteModal, setDeleteModal] = useState({
    userId: null,
    isOpen: false,
  });
  const [search, setSearch] = useState();
  const [visible, setVisible] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isModalShow, setIsModalShow] = useState(false);
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [screen, setScreen] = useState(defaultScreen);
  const [deleteGroup, setDeleteGroup] = useState();

  const [apikeyModal, setApikeyModal] = useState({
    screen: null,
    isOpen: false,
  });
  const [selectedGroup, setSelectedGroup] = useState('all');
  const [tempSelectedGroup, setTempSelectedGroup] = useState(selectedGroup);
  // const [siteName, setSiteName] = useState('');
  // const [organizationId, setOrganizationId] = useState('');
  const [searchError, setSearchError] = useState(null);

  const [dropdownOpen, setDropdownOpen] = useState(false);

  // Screen scheduling states
  const [selectedScreenScheduling, setSelectedScreenScheduling] =
    useState('all');
  const [isModalSchedulingShow, setIsModalSchedulingShow] = useState(false);
  const [deletedScreenScheduling, setDeletedScreenScheduling] = useState(null);
  const [
    isDeleteScreenSchedulingModalShow,
    setIsDeleteScreenSchedulingModalShow,
  ] = useState(false);
  const [tempSelectedScreenScheduling, setTempSelectedScreenScheduling] =
    useState(selectedScreenScheduling);
  const [schedulingDropdownOpen, setSchedulingDropdownOpen] = useState(false);

  const dispatch = useDispatch();

  const uid = userData.id;

  useEffect(() => {
    dispatch(fetchScreens({ siteId }));
    dispatch(fetchScreenGroups({ siteId }));
    dispatch(fetchScreenScheduling({ siteId }));
    dispatch(fetchTemplates({ siteId }));
    return () => dispatch(clearUsersData());
  }, [dispatch, role, siteId]); // eslint-disable-line

  useEffect(() => {
    if (deleted && !loading) {
      setDeleteModal((prevState) => ({
        userId: null,
        isOpen: !prevState.isOpen,
      }));
      dispatch(fetchScreens({ siteId }));

      dispatch(fetchTemplates({ siteId }));
    }
  }, [deleted, loading]); // eslint-disable-line

  useEffect(() => {
    log(updated);
    if (updated && !loading) {
      dispatch(fetchScreens({ siteId }));
      dispatch(fetchTemplates({ siteId }));
      setVisible(false);
    }
  }, [updated, loading]); // eslint-disable-line

  const handleAddCategory = () => {
    dispatch(
      setScreenGroup({
        name: '',
        description: '',
      })
    );

    setIsModalShow(true);
  };

  const setScreenGroupData = (data) => {
    dispatch(setScreenGroup(data));
  };

  const handleEditCategory = (id) => {
    const findCategory = screenGroupList.find((cat) => cat._id === id);
    console.log(id, 'id');
    console.log(findCategory, 'findCategory');
    // setIsEditing(true);
    dispatch(setScreenGroup(findCategory));
    setIsModalShow(true);
  };

  const handleDeleteCategory = async (item) => {
    setDeleteGroup(item);
    setIsDeleteModal(true);
  };
  const getCategory = () => {
    const findCategory = screenGroupList.find(
      (cat) => cat._id === selectedGroup
    );
    return findCategory?.name;
  };
  // const downloadJSONConfig = (selectedScreen) => {
  //   const site = sites.filter((site) => site._id === siteId);
  //   const organizationId = site && site[0] ? site.organizationId : '';
  //   const json = {
  //     organizationId,
  //     siteId,
  //     screenId: selectedScreen._id,
  //     email: '',
  //     password: '',
  //     url: 'https://premise-api.adactive.asia',
  //     mode: 'offline',
  //   };
  //   const content = JSON.stringify(json);
  //   const filename = `${siteName} ${selectedScreen.name}.json`;
  //   const contentType = 'text/json';
  //
  //   const a = document.createElement('a');
  //   const file = new Blob([content], { type: contentType });
  //   a.href = URL.createObjectURL(file);
  //   a.download = filename;
  //   a.click();
  // };

  const onCreate = (values) => {
    const action = isEditing ? modifyScreen : createScreen;
    log(values, '<<<< values screen oncreate');
    dispatch(action(values));
  };

  const onNewScreenHandler = () => {
    log('handle new screen');
    setScreen(defaultScreen);
    setIsEditing(false);
    setVisible(true);
  };

  const onRemoveButtonClickHandler = (screenId) => {
    setDeleteModal((prevState) => ({
      screenId,
      isOpen: !prevState.isOpen,
    }));
  };

  const onCreateScreenGroup = () => {
    const action = screenGroup._id ? modifyScreenGroup : createScreenGroup;

    dispatch(
      action(
        { uid, ...screenGroup, siteId, id: screenGroup._id },
        setIsModalShow
      )
    );
  };
  const onCloseModalHandler = () => {
    setDeleteModal({ screenId: null, isOpen: false });
  };

  const onCloseModalApikeyHandler = () => {
    setApikeyModal({ screen: null, isOpen: false });
  };
  const onDeleteScreenHandler = () => {
    dispatch(deleteScreen({ id: deleteModal.screenId, siteId }));
  };

  const handleSearch = (e) => {
    setSearchError(null);
    if (!regexInput(e.target.value) && e.target.value) {
      setSearchError('Search cannot using special character');
    }
    setSearch(e.target.value);
  };

  const handleGoTo = (screen) => {
    dispatch(
      setActiveScreen(screen, () =>
        history.push(`/${siteId}/screen/${siteName}/${screen._id}`)
      )
    );
  };

  const handleSetPlaylist = () => {
    setSelectedGroup(tempSelectedGroup);
    setDropdownOpen(false);
  };

  const handleDeleteScreenGroup = () => {
    dispatch(
      deleteScreenGroup({ id: deleteGroup._id, siteId }, () =>
        setIsDeleteModal(false)
      )
    );
    setSelectedGroup('all');
  };

  const handleCancelDeleteCategory = () => {
    setDeleteGroup(null);
    setIsDeleteModal(false);
  };

  // Screen scheduling handlers
  const handleAddScreenScheduling = () => {
    dispatch(
      setScreenScheduling({
        name: '',
        description: '',
        screenId: '',
        activeConfigIndices: [],
      })
    );
    setIsModalSchedulingShow(true);
  };

  const handleEditScreenScheduling = (id) => {
    const findScheduling = screenSchedulingList.find((cat) => cat._id === id);
    dispatch(setScreenScheduling(findScheduling));
    setIsModalSchedulingShow(true);
  };

  const handleDeleteScreenScheduling = async (item) => {
    setDeletedScreenScheduling(item);
    setIsDeleteScreenSchedulingModalShow(true);
  };

  const getScreenScheduling = () => {
    const findScheduling = screenSchedulingList.find(
      (cat) => cat._id === selectedScreenScheduling
    );
    return findScheduling?.name;
  };

  const handleSetScreenScheduling = () => {
    setSelectedScreenScheduling(tempSelectedScreenScheduling);
    setSchedulingDropdownOpen(false);
  };

  const handleOkDeleteScreenScheduling = () => {
    dispatch(
      deleteScreenScheduling({ id: deletedScreenScheduling._id, siteId }, () =>
        setIsDeleteScreenSchedulingModalShow(false)
      )
    );
    setSelectedScreenScheduling('all');
  };

  const handleCancelDeleteScreenScheduling = () => {
    setDeletedScreenScheduling(null);
    setIsDeleteScreenSchedulingModalShow(false);
  };

  const onCreateScreenScheduling = (finalScheduling) => {
    const action = screenScheduling._id
      ? modifyScreenScheduling
      : createScreenScheduling;

    dispatch(
      action(
        {
          ...screenScheduling,
          ...finalScheduling,
          siteId,
          id: screenScheduling._id,
        },
        setIsModalSchedulingShow
      )
    );
  };

  const data = search
    ? screensList.filter((el) => {
        const clonedElem = { ...el };
        return clonedElem.name.toLowerCase().includes(search.toLowerCase());
      })
    : screensList;

  const permDeleteMessage = useFormatMessage('Screens.permDelete');

  return (
    <section className="screens">
      {deleteModal.isOpen && (
        <ModalDeleteConfirmation
          title="Delete Screen"
          onCloseHandler={onCloseModalHandler}
          onDeleteHandler={onDeleteScreenHandler}
          description={permDeleteMessage}
          visible={deleteModal.isOpen}
        />
      )}

      <ModalDelete
        isVisible={isDeleteModal}
        onOk={handleDeleteScreenGroup}
        onCancel={handleCancelDeleteCategory}
        title="Delete Playlist"
        subtitle={deleteGroup ? deleteGroup.name : ''}
        loading={loadingScreenGroup}
      />

      <ModalMediaCategoryForm
        visible={isModalShow}
        onCancel={() => {
          setIsModalShow(false);
        }}
        onCreate={onCreateScreenGroup}
        category={screenGroup}
        setCategory={setScreenGroupData}
        isEditing={!!screenGroup._id}
      />

      <ModalScreenSchedulingForm
        visible={isModalSchedulingShow}
        onCancel={() => setIsModalSchedulingShow(false)}
        onCreate={onCreateScreenScheduling}
        scheduling={screenScheduling}
        setScheduling={(scheduling) =>
          dispatch(setScreenScheduling(scheduling))
        }
        isEditing={!!screenScheduling._id}
        siteId={siteId}
      />

      <ModalDelete
        isVisible={isDeleteScreenSchedulingModalShow}
        onOk={handleOkDeleteScreenScheduling}
        onCancel={handleCancelDeleteScreenScheduling}
        title="Delete Screen Scheduling"
        subtitle={deletedScreenScheduling?.name || ''}
        loading={loadingScreenScheduling}
      />

      <div className="screens__nav">
        <div className="screens__search-wrapper">
          <div className="media-categories__search">
            <i className="feather-search" />
            <input
              type="text"
              placeholder="Search..."
              value={search}
              onChange={handleSearch}
            />
          </div>
          {searchError && <div className="search-error">{searchError}</div>}
        </div>

        <div className="screens__button-group">
          {/* <Link
            className="button-primary-outline mr-2"
            to={`/${siteId}/information/${siteName}/templates`}
          >
            <CopyIcon size={18} color="#64D5D2" /> Template Library
          </Link> */}
          <button className="button-primary" onClick={onNewScreenHandler}>
            <i className="feather-plus" /> Add Screen
          </button>
        </div>
      </div>
      {visible && (
        <ModalScreenForm
          visible
          onCancel={() => {
            setVisible(false);
          }}
          onCreate={onCreate}
          screen={screen}
          setScreen={setScreen}
          isEditing={isEditing}
        />
      )}
      {apikeyModal.isOpen && (
        <ModalConfirmation
          title={
            apikeyModal.screen?.apiKeyPreview
              ? 'Revoke API Key?'
              : 'Generate New API Key?'
          }
          onConfirmHandler={() =>
            apikeyModal.screen?.apiKeyPreview
              ? dispatch(
                  revokeApiKey({ screenId: apikeyModal.screen._id, siteId })
                )
              : dispatch(
                  generateApiKey(
                    { screenId: apikeyModal.screen._id, siteId },
                    onCloseModalApikeyHandler()
                  )
                )
          }
          onCloseHandler={onCloseModalApikeyHandler}
          description={
            apikeyModal.screen.apiKeyPreview
              ? `Revoking the API key will immediately disable this screen's ability to fetch content.
Are you sure you want to proceed?`
              : `Are you sure you want to generate a new API key for this screen?`
          }
          visible={apikeyModal.isOpen}
        />
      )}
      <div className="media-header">
        <div className="media-header-left">
          <div
            className="playlist-wrapper"
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            <div className="playlist-selection">
              <ForwardIcon />
              <span>
                {selectedGroup === 'all'
                  ? 'All Screen Groups'
                  : getCategory(selectedGroup)}
              </span>
            </div>
            <i
              className={`feather-chevron-down ${
                dropdownOpen ? 'playlist-open' : 'playlist-closed'
              }`}
            />

            <CategoryDropdown
              categories={screenGroupList}
              setTempSelectedCategory={(id) => setTempSelectedGroup(id)}
              handleEditCategory={
                role === 'superadmin'
                  ? (cat) => handleEditCategory(cat._id)
                  : null
              }
              handleDeleteCategory={
                role === 'superadmin'
                  ? (cat) => handleDeleteCategory(cat)
                  : null
              }
              modalOpen={dropdownOpen}
              handleSetPlaylist={handleSetPlaylist}
              title="Screen Group"
              tempSelectedCategory={tempSelectedGroup}
              handleNew={role === 'superadmin' ? handleAddCategory : null}
              filter
            />
          </div>

          <DropdownWrapper
            setIsOpen={setSchedulingDropdownOpen}
            isOpen={schedulingDropdownOpen}
            label={'Screen Scheduling'}
            getItemLabel={getScreenScheduling}
            selectedItem={selectedScreenScheduling}
          >
            <CategoryDropdown
              categories={screenSchedulingList}
              title={'Screen Scheduling'}
              setTempSelectedCategory={(id) =>
                setTempSelectedScreenScheduling(id)
              }
              handleEditCategory={(cat) => handleEditScreenScheduling(cat._id)}
              handleDeleteCategory={(cat) => handleDeleteScreenScheduling(cat)}
              modalOpen={schedulingDropdownOpen}
              handleSetPlaylist={() => handleSetScreenScheduling()}
              tempSelectedCategory={tempSelectedScreenScheduling}
              handleNew={handleAddScreenScheduling}
              filter={true}
            />
          </DropdownWrapper>
        </div>
      </div>
      <div className="screens__table">
        {loading ? (
          <ClipLoader />
        ) : (
          <div className="media-content-wrapper">
            <div className="media-content">
              <div className="media-list-content">
                {_.chunk(data, 3).map((chunk, index) => {
                  return (
                    <div className="media-list-chunk" key={index}>
                      {chunk.map((screen) => (
                        <div
                          key={screen._id}
                          data-id={screen._id}
                          className="media-list"
                        >
                          <Cards
                            data={screen}
                            type="screen"
                            isShowMedia
                            editAction={() => {
                              setScreen(screen);
                              setVisible(true);
                              setIsEditing(true);
                            }}
                            keyAction={() =>
                              setApikeyModal({ screen, isOpen: true })
                            }
                            cardClickAction={() => handleGoTo(screen)}
                            deleteAction={() =>
                              onRemoveButtonClickHandler(screen._id)
                            }
                            downloadAction={() =>
                              dispatch(
                                downloadScreenConfig({
                                  screenId: screen._id,
                                  siteName,
                                  screenName: screen.name,
                                })
                              )
                            }
                            isDownload
                            isClickable
                            onClick={() => handleGoTo(screen)}
                          />
                        </div>
                      ))}
                      {chunk.length < 2 && <div className="media-list-empty" />}
                      {chunk.length < 3 && <div className="media-list-empty" />}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          // <ScreenCard
          //   data={data}
          //   onRemoveButtonClickHandler={(id) => onRemoveButtonClickHandler(id)}
          //   onEditButtonClickHandler={(record) => {
          //     setScreen(record);
          //     setVisible(true);
          //     setIsEditing(true);
          //   }}
          //   handleGoTo={handleGoTo}
          // />
        )}
        {error && 'Show error'}
      </div>
    </section>
  );
}
